// extracted by css-extract-rspack-plugin
export default {"IconRoot":"lKZ64"};